import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-truncate"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["iconn_chip", $setup.chipClasses]),
    onClick: $setup.handleClick
  }, [
    ($props.avatar)
      ? (_openBlock(), _createBlock($setup["Avatar"], {
          key: 0,
          pathImg: $props.avatarImageUrl,
          size: "xs"
        }, null, 8 /* PROPS */, ["pathImg"]))
      : _createCommentVNode("v-if", true),
    _renderSlot(_ctx.$slots, "left", {}, () => [
      ($props.iconLeft)
        ? (_openBlock(), _createBlock($setup["IconMaterial"], {
            key: 0,
            icon: $props.iconLeft,
            size: $setup.iconSize,
            color: $setup.iconColor,
            variant: $props.iconLeftVariant
          }, null, 8 /* PROPS */, ["icon", "size", "color", "variant"]))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      ($props.text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($props.text), 1 /* TEXT */))
        : _createCommentVNode("v-if", true)
    ]),
    _renderSlot(_ctx.$slots, "right", {}, () => [
      ($props.iconRight)
        ? (_openBlock(), _createBlock($setup["IconMaterial"], {
            key: 0,
            icon: $props.iconRight,
            size: $setup.iconSize,
            color: $setup.iconColor,
            variant: $props.iconRightVariant
          }, null, 8 /* PROPS */, ["icon", "size", "color", "variant"]))
        : _createCommentVNode("v-if", true)
    ]),
    ($props.close)
      ? (_openBlock(), _createBlock($setup["IconMaterial"], {
          key: 1,
          class: "cursor-pointer",
          icon: "highlight_off",
          variant: "outlined",
          size: $setup.iconSize,
          color: $setup.iconColor,
          onClick: _withModifiers($setup.handleClose, ["stop"])
        }, null, 8 /* PROPS */, ["size", "color"]))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}